import "./OurServices.css";
import Image1 from "../assests/images/Servicecard1_image.png";
import Image2 from "../assests/images/Servicecard2_image.png";
import Image3 from "../assests/images/Servicecard3_image.png";
import Image4 from "../assests/images/Servicecard4_image.png";
import Image5 from "../assests/images/Servicecard5_image.png";
import Automation from "../assests/images/Automation.png";
import GameDevelopment from "../assests/images/Game-Development.png";
import ArVr from "../assests/images/ARVR.png";
import OfflineActivities from "../assests/images/Offline-Activities.png";
import PublicRelations from "../assests/images/Service-Images.png";
import { useState, useEffect } from "react";
import { ChevronLeft, ChevronRight, Users, Play, Settings, PencilRuler, Megaphone, ChevronsLeftRightEllipsis, BrushCleaning, Joystick, Speech, PersonStanding, Gamepad2, Box } from "lucide-react";

const OurServices = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);

  const services = [
    {
      icon: <ChevronsLeftRightEllipsis size={48} />,
      title: "Development",
      description:
        "Creating innovative, scalable, and robust software solutions tailored to your specific needs—web, mobile, and enterprise-grade applications.",
      bgColor: "bg-yellow",
      textColor: "text-dark",
    },
    {
      icon: <PencilRuler size={48} />,
      title: "Design",
      description:
        "Delivering striking visual identities and seamless UI/UX that’s both functional and beautiful—across web, product, and brand systems.",
      bgColor: "bg-dark",
      textColor: "text-white",
    },
    {
      icon: <Megaphone size={48} />,
      title: "Digital Marketing",
      description:
        "From SEO to paid ads and performance campaigns, we engineer visibility that translates into engagement, traffic, and ROI.",
      bgColor: "bg-yellow",
      textColor: "text-dark",
    },
    {
      icon: <Users size={48} />,
      title: "Political Consultation",
      description:
        "Data-backed strategies, targeted messaging, and media war rooms that win elections and shape public perception.",
      bgColor: "bg-dark",
      textColor: "text-white",
    },
    {
      icon: <PersonStanding size={48} />,
      title: "Animation - 2D/3D/CGI",
      description:
        "Turn concepts into motion with high-quality 2D and 3D animations that bring clarity, engagement, and brand elevation.",
      bgColor: "bg-yellow",
      textColor: "text-dark",
    },
    {
      icon: <Settings size={48} />,
      title: "Automation",
      description:
        "Transform workflows with smart automation tools that save time, reduce error, and unlock efficiency.",
      bgColor: "bg-dark",
      textColor: "text-white",
    },
    {
      icon: <Gamepad2 size={48} />,
      title: "Game Development",
      description:
        "From ideation to launch, we build immersive, addictive games that captivate users and power brand stories.",
      bgColor: "bg-yellow",
      textColor: "text-dark",
    },
    {
      icon: <Speech size={48} />,
      title: "Public Relations",
      description:
        "We craft and control the narrative with strategic PR campaigns that position your brand as a trusted industry leader.",
      bgColor: "bg-dark",
      textColor: "text-white",
    },
    {
      icon: <Box size={48} />,
      title: "AR/VR Solutions",
      description:
        "Push the boundaries of digital with immersive AR/VR experiences that engage users and redefine interaction.",
      bgColor: "bg-yellow",
      textColor: "text-dark",
    },
  ];

  const cardsPerSlide = window.innerWidth >= 992 ? 3 : 1;
  const totalSlides = Math.ceil(services.length / cardsPerSlide);

  const nextSlide = () => {
    if (isAnimating) return;
    setIsAnimating(true);
    setCurrentSlide((prev) => (prev + 1) % totalSlides);
  };

  const prevSlide = () => {
    if (isAnimating) return;
    setIsAnimating(true);
    setCurrentSlide((prev) => (prev - 1 + totalSlides) % totalSlides);
  };

  // Reset animation state after transition
  useEffect(() => {
    if (isAnimating) {
      const timeout = setTimeout(() => {
        setIsAnimating(false);
      }, 300);
      return () => clearTimeout(timeout);
    }
  }, [isAnimating]);

  // Get services for current slide
  const getCurrentSlideServices = () => {
    const startIndex = currentSlide * cardsPerSlide;
    return services.slice(startIndex, startIndex + cardsPerSlide);
  };

  // const services = [
  //   {
  //     id: 1,
  //     title: "Development",
  //     description:
  //       "Creating innovative, scalable, and robust software solutions tailored to your specific needs—web, mobile, and enterprise-grade applications.",
  //     iconUrl: Image1, // Placeholder for development icon
  //     bgColor: "#E34D90",
  //   },
  //   {
  //     id: 2,
  //     title: "Design",
  //     description:
  //       "Delivering striking visual identities and seamless UI/UX that’s both functional and beautiful—across web, product, and brand systems.",
  //     iconUrl: Image2,
  //     bgColor: "#7340DD",
  //   },
  //   {
  //     id: 3,
  //     title: "Digital Marketing",
  //     description:
  //       "From SEO to paid ads and performance campaigns, we engineer visibility that translates into engagement, traffic, and ROI.",
  //     iconUrl: Image3, // Placeholder for digital marketing icon
  //     bgColor: "#5993EE",
  //   },
  //   {
  //     id: 4,
  //     title: "Political Consultation",
  //     description:
  //       "Data-backed strategies, targeted messaging, and media war rooms that win elections and shape public perception.",
  //     iconUrl: Image4,
  //     bgColor: "#D45ED5",
  //   },
  //   {
  //     id: 5,
  //     title: "Animation - 2D/3D/CGI",
  //     description:
  //       "Turn concepts into motion with high-quality 2D and 3D animations that bring clarity, engagement, and brand elevation.",
  //     iconUrl: Image5,
  //     bgColor: "#C82DD0",
  //   },
  //   {
  //     id: 6,
  //     title: "Automation",
  //     description:
  //       "Transform workflows with smart automation tools that save time, reduce error, and unlock efficiency.",
  //     iconUrl: Automation,
  //     bgColor: "#D45ED5",
  //   },
  //   {
  //     id: 7,
  //     title: "Game Development",
  //     description:
  //       "From ideation to launch, we build immersive, addictive games that captivate users and power brand stories.",
  //     iconUrl: GameDevelopment,
  //     bgColor: "#5993EE",
  //   },
  //   {
  //     id: 8,
  //     title: "Public Relations",
  //     description:
  //       "We craft and control the narrative with strategic PR campaigns that position your brand as a trusted industry leader.",
  //     iconUrl: PublicRelations,
  //     bgColor: "#7340DD",
  //   },
  //   {
  //     id: 9,
  //     title: "AR/VR Solutions",
  //     description:
  //       "Push the boundaries of digital with immersive AR/VR experiences that engage users and redefine interaction.",
  //     iconUrl: ArVr,
  //     bgColor: "#E34D90",
  //   },
  //   {
  //     id: 10,
  //     title: "Offline Activities",
  //     description:
  //       "We take your brand beyond the screen with high-impact print ads, hoardings, and on-ground campaigns that drive real-world visibility and recall.",
  //     iconUrl: OfflineActivities,
  //     bgColor: "#C82DD0",
  //   }
  // ];

  return (
    <>
      {/* <div id="ourservices" className="container mt-100 mb-100">
        <h1 className="title-text">Our</h1>
        <h1 className="title-text">Services</h1>

        <div className="row row-cols-1 row-cols-sm-2 row-cols-lg-3 row-cols-xl-5 g-4 justify-content-center mt-3">
          {services.map((service) => (
            <div key={service.id} className="col d-flex px-1">
              <div
                className="service-card w-100"
                style={{ backgroundColor: service.bgColor }}
              >
                <div className="service-card-image">
                  <img src={service.iconUrl} alt={`${service.title} Icon`} />
                </div>
                <div className="service-card-body">
                  <h5 className="service-card-title">{service.title}</h5>
                  <p className="service-card-description">
                    {service.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div> */}
      <div
        className="container-fluid py-5" id="ourservices"
      >
        <div className="container">
          <div className="row">
            <div className="col-12 text-center mb-5">
              <h2 className="display-4 fw-bold mb-0">
                Services <span className="text-yellow">We Offer</span>
              </h2>
            </div>
          </div>

          <div className="row align-items-center">
            {/* Left Arrow */}
            <div className="col-1 text-center">
              <button
                className="btn btn-link p-0 border-0"
                onClick={prevSlide}
                style={{ fontSize: "3rem", color: "#333" }}
              >
                <ChevronLeft size={60} />
              </button>
            </div>

            {/* Carousel Content */}
            <div className="col-10">
              <div className="row">
                {getCurrentSlideServices().map((service, index) => (
                  <div
                    key={`${currentSlide}-${index}`}
                    className="col-lg-4 col-12 mb-4 mb-lg-0"
                    style={{
                      animation: `fadeInUp 0.6s ease-out ${index * 0.1}s both`,
                    }}
                  >
                    <div
                      className={`card border-0 rounded-4 h-100 ${service.bgColor} ${service.textColor}`}
                      style={{
                        minHeight: "400px",
                        transform: "translateY(0)",
                        transition: "all 0.3s ease-out",
                      }}
                    >
                      <div className="card-body d-flex flex-column justify-content-center align-items-center text-center p-4">
                        <div
                          className="mb-4"
                          style={{
                            animation: "scaleIn 0.4s ease-out 0.3s both",
                          }}
                        >
                          {service.icon}
                        </div>
                        <h3
                          className="card-title h2 fw-bold mb-4"
                          style={{
                            animation: "fadeInUp 0.5s ease-out 0.4s both",
                          }}
                        >
                          {service.title}
                        </h3>
                        <p
                          className="card-text lead"
                          style={{
                            animation: "fadeInUp 0.5s ease-out 0.5s both",
                          }}
                        >
                          {service.description}
                        </p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Right Arrow */}
            <div className="col-1 text-center">
              <button
                className="btn btn-link p-0 border-0"
                onClick={nextSlide}
                style={{ fontSize: "3rem", color: "#333" }}
              >
                <ChevronRight size={60} />
              </button>
            </div>
          </div>

          {/* Indicators */}
          <div className="row mt-4">
            <div className="col-12 text-center">
              {Array.from({ length: totalSlides }, (_, index) => (
                <button
                  key={index}
                  className={`btn btn-sm rounded-circle mx-1 ${
                    index === currentSlide
                      ? "btn-warning"
                      : "btn-outline-secondary"
                  }`}
                  style={{ width: "12px", height: "12px", padding: "0" }}
                  onClick={() => setCurrentSlide(index)}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default OurServices;
